import { render, staticRenderFns } from "./reminddetails.vue?vue&type=template&id=5ec05d7c&scoped=true"
import script from "./reminddetails.vue?vue&type=script&lang=js"
export * from "./reminddetails.vue?vue&type=script&lang=js"
import style0 from "./reminddetails.vue?vue&type=style&index=0&id=5ec05d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec05d7c",
  null
  
)

export default component.exports